import { setWindowLocation } from 'utils/setWindowLocation';
import { getMailroomUrl } from './getMailroomUrl';

export const redirectToMailroom = (region: OP.Env, orgId: number) => {
  setWindowLocation(`${getMailroomUrl(region)}/o/${orgId}`);
};
